import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { createGeneratedSlugField } from './create-generated-slug-field.js'

export function createGeneratedSlugFieldForTitle(
  fields: SchemaField[],
  titleField: SchemaField
): SchemaField {
  const slugField = createGeneratedSlugField(fields)
  return titleField.slot ? { ...slugField, slot: titleField.slot } : slugField
}
